import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { useConfigureEverbridgeTokenModal } from '../../../components/configureEverbridgeTokenModal/useConfigureEverbridgeTokenModal';
import { useSpinner } from '../../../customHooks';
import { everbridgeWebhookURL } from '../../../config/index';
import { Status, WEBHOOK_PLACEHOLDER,statusCode } from '../../../common/constants';
import { fetchEverbridgeGroupData } from './listEverbridgeGroupSlice';
import { selector as everbridgeGroupApi } from './listEverbridgeGroupSlice';
import { actions as everbridgeActions } from '../../../components/configureEverbridgeTokenModal/configureEverbridgeTokenSlice';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { IEverbridgeGroupApi } from '../../../common/types/everbridgeTypes';
import useNotification from '../../../components/notification/useNotification';

export interface IEverbridgeGroupApiState {
  deviceApi: IEverbridgeGroupApi;
}

export const useEverbridge = () => {
  const dispatch: ThunkDispatch<IEverbridgeGroupApiState, undefined, Action> =
    useDispatch();
  const [text, setText] = useState<string>(WEBHOOK_PLACEHOLDER.PLACEHOLDER);
  const [copied, setCopied] = useState<boolean>(false);
  const [webhookUrlUpdateRequired, setWebhookUrlUpdateRequired] =
    useState<boolean>(false);
  const { everbridgeTokenResponse } = useConfigureEverbridgeTokenModal();
  const everbridgeGroupResponse = useSelector(everbridgeGroupApi);
  const { showWarningNotification } = useNotification();

  useSpinner(everbridgeTokenResponse.status);
  useSpinner(everbridgeGroupResponse.status);

  useEffect(() => {
    dispatch(fetchEverbridgeGroupData())
      .then((response: any) => {
        if (response?.meta?.requestStatus === "fulfilled" && response.payload.userId) {
          dispatch(everbridgeActions.setUserId(response.payload.userId));
        } else {
          const responseData: { message?: string; status?: number } =
            response?.payload?.response?.data;
          if (responseData?.status !== statusCode.badRequest)
            showWarningNotification(
              responseData?.message || "Something went wrong.",
            );
        }
      })
      .catch((err: any) => {});
  }, []);

  useEffect(() => {
    if (
      everbridgeTokenResponse?.userId &&
      everbridgeTokenResponse?.organizationId &&
      everbridgeTokenResponse?.webhookSecret
    ) {
      setText(
        `${everbridgeWebhookURL}/${everbridgeTokenResponse.organizationId}/${everbridgeTokenResponse.webhookSecret}?userId=${everbridgeTokenResponse.userId}`,
      );
    }
  }, [everbridgeTokenResponse.status]);

  useEffect(() => {
    if (
      everbridgeGroupResponse.status === Status.SUCCESS &&
      everbridgeGroupResponse?.everbridgeGroup?.userId &&
      everbridgeGroupResponse?.everbridgeGroup?.organizationId &&
      everbridgeGroupResponse?.everbridgeGroup?.webhookSecret
    ) {
      const { organizationId, webhookSecret, userId, webhookUrlUpdateRequired: updateRequired } =
        everbridgeGroupResponse.everbridgeGroup;
      setText(
        `${everbridgeWebhookURL}/${organizationId}/${webhookSecret}?userId=${userId}`,
      );
      setWebhookUrlUpdateRequired(!!updateRequired);
    } else if (everbridgeGroupResponse.status === Status.SUCCESS) {
      setText(WEBHOOK_PLACEHOLDER.PLACEHOLDER);
      setWebhookUrlUpdateRequired(
        !!everbridgeGroupResponse?.everbridgeGroup?.webhookUrlUpdateRequired,
      );
    }
  }, [everbridgeGroupResponse.status]);

  return {
    text,
    setText,
    copied,
    setCopied,
    webhookUrlUpdateRequired,
  };
};